import { System } from "../../../../context";

type State = {
  filters: {
    search: string;
    host: string[];
    type: string[];
  };
  add_system_accesses_modal: {
    open: boolean;
    system: System | null;
  };
};

type Action =
  | {
      type: "add-filter";
      name: "search" | "host" | "type";
      value: string;
    }
  | {
      type: "remove-filter";
      name: "search" | "host" | "type";
      value: string;
    }
  | {
      type: "open-add-system-accesses-modal";
      system: System;
    }
  | {
      type: "close-add-system-accesses-modal";
    }
  | {
      type: "reset";
    };

export function init(state: Partial<State> = {}): State {
  return {
    filters: {
      search: "",
      host: [],
      type: [],
    },
    add_system_accesses_modal: {
      open: false,
      system: null,
    },
  };
}

export function reducer(state: State, action: Action): State {
  switch (action.type) {
    case "add-filter":
      return {
        ...state,
        filters: {
          ...state.filters,
          [action.name]:
            action.name === "search"
              ? action.value
              : state.filters[action.name].concat(action.value),
        },
      };
    case "remove-filter":
      return {
        ...state,
        filters: {
          ...state.filters,
          [action.name]:
            action.name === "search"
              ? ""
              : state.filters[action.name].filter(
                  (value) => value !== action.value
                ),
        },
      };
    case "open-add-system-accesses-modal":
      return {
        ...state,
        add_system_accesses_modal: {
          open: true,
          system: action.system,
        },
      };
    case "close-add-system-accesses-modal":
      return {
        ...state,
        add_system_accesses_modal: {
          open: false,
          system: null,
        },
      };
    case "reset":
      return init();
    default:
      return state;
  }
}
